import React, { FC, useEffect, useState } from 'react'
import { StyledIconCross, StyledTNSlideToast } from './TNSlideToast.styled'
import { IconAlertCircleTN, IconCheckmarkTN } from '../../icons'

export type ToastType = 'success' | 'error'

export interface TNSlideToastProps {
    text: string
    type?: ToastType
    show?: boolean
    onClose: () => void
    forceRender?: boolean
}

export const TNSlideToast: FC<TNSlideToastProps> = ({
    text,
    show = false,
    type,
    onClose,
    forceRender = false,
}) => {
    const [showToast, setShowToast] = useState<boolean>(forceRender)

    useEffect(() => {
        setShowToast(show)
        if (show) {
            const autoDismissTimer = setTimeout(() => {
                setShowToast(false)
                onClose()
            }, 1000)
            return () => autoDismissTimer && clearTimeout(autoDismissTimer)
        }
    }, [show, onClose])

    return (
        <StyledTNSlideToast
            show={showToast}
            type={type}
            forceRender={forceRender}
        >
            <div>
                {type === 'success' ? (
                    <IconCheckmarkTN strokeColor="#fff" />
                ) : (
                    <IconAlertCircleTN strokeColor="#fff" />
                )}
                <span>{text}</span>
                <StyledIconCross onClick={onClose} />
            </div>
        </StyledTNSlideToast>
    )
}
